var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enterpriseBigData index"},[_vm._v("\n  企业实时运行平台\n  \n")])}
var staticRenderFns = []

export { render, staticRenderFns }